module.exports = require("-!../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./facilities.vue")
;(typeof module.exports === "function" ? module.exports.options : module.exports).template = require("-!vue-html!../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./facilities.vue")
if (module.hot) {
(function () {
var hotAPI = require("E:\\zhe_li_you_xuan\\hotelInfo\\node_modules\\vue-hot-reload-api\\index.js")
hotAPI.install(require("vue"))
if (!hotAPI.compatible) return
var id = "-!../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./facilities.vue"
hotAPI.createRecord(id, module.exports)
module.hot.accept(["-!../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./facilities.vue","-!vue-html!../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./facilities.vue"], function () {
var newOptions = require("-!../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./facilities.vue")
var newTemplate = require("-!vue-html!../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./facilities.vue")
hotAPI.update(id, newOptions, newTemplate)
})
})()
}


//////////////////
// WEBPACK FOOTER
// ./src/views/facilities.vue
// module id = 90
// module chunks = 0